"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bizUserRegisterReducer = exports.bizUserRegisterActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'BizUserRegister';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_ENTRY: PREFIX + 'SetEntry',
  SET_CONTENT: PREFIX + 'SetContent',
  SET_ENTRIES: PREFIX + 'SetEntries',
  SET_SYSTEM_LOGIN: PREFIX + 'SetSystemLogin',
  SET_ACCESS_AUTH_SELECT: PREFIX + 'SetAccessAuthSelect',
  CLEAR: PREFIX + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  ENTER: 'enter',
  RESULT: 'result'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.ENTER,
  entries: {
    // ID
    id: '',
    // 会社
    kaishaCd: '',
    kaishaNm: '',
    // 組織
    soshikiCd: '',
    soshikiNmFull: '',
    // アクセス権限
    accessAuth: '',
    // カナ姓
    shainSeiKtkn: '',
    // カナ名
    shainMeiKtkn: '',
    // 漢字姓
    shainSeiKanji: '',
    // 漢字名
    shainMeiKanji: '',
    // ユーザ設定コード
    customerCd: '',
    // 勤務場所
    workplaceTdfkCd: '',
    areaCd: '',
    areaNm: '',
    site: '',
    siteNo: '',
    siteBuildingNm: '',
    siteOtherNm: '',
    // 自宅場所
    jusyoTdfkCd1: '',
    // その他滞在場所
    jusyoTdfkCd2: '',
    // 連絡先MAIL1
    mailAddress1: '',
    // 連絡先MAIL2
    mailAddress2: '',
    // 連絡先MAIL3
    mailAddress3: '',
    // パスワード
    webAuthPassword: '',
    // 新しいパスワード
    newWebAuthPassword: '',
    // 更新日時
    updDt: ''
  },
  accessAuthSelect: []
};

/**
 * アクション定義
 */
const bizUserRegisterActions = exports.bizUserRegisterActions = (0, _reduxActions.createActions)({
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SYSTEM_LOGIN]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ACCESS_AUTH_SELECT]: function () {
    return {
      accessAuthSelect: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.CLEAR);

/**
 * Reducer定義
 */
const bizUserRegisterReducer = exports.bizUserRegisterReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_GROUP_NM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      groupNm: action.payload.groupNm
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), action.payload.entries)
    });
  },
  [TYPES.SET_SYSTEM_LOGIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.key]: action.payload.value
  }),
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  },
  [TYPES.SET_ACCESS_AUTH_SELECT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      accessAuthSelect: [...action.payload.accessAuthSelect]
    });
  }
}, INIT_STATE);